/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Invite_QInputs */



/**
* | output |
* | --- |
* | "My customer did not receive the invitation." |
*
* @param {Partner_Faq_Invite_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_invite_q = /** @type {((inputs?: Partner_Faq_Invite_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Invite_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mein Kunde hat die Einladung nicht erhalten.")
	return /** @type {LocalizedString} */ ("My customer did not receive the invitation.")
});